import Image from 'next/image';
import type { FC } from 'react';
import React from 'react';
import { Container } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import HomeNewCounselingForm from './HomeNewCounselingForm';
const HomeNewCounseling: FC = () => {
  return <div className="bg-blueOne" data-sentry-component="HomeNewCounseling" data-sentry-source-file="HomeNewCounseling.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="HomeNewCounseling.tsx">
        <div className="flex flex-col justify-between pt-8 sm:py-8 lg:flex-row">
          <div className="mb-6 flex-1 text-right lg:max-w-[725px] ">
            <h2 className="text-center text-2xl  font-bold text-blueFive sm:mt-6 sm:text-right sm:text-4xl md:mt-12 ">
              ثبت‌نام در خبرنامه
            </h2>
            <p className=" mt-4 text-center text-blueFive  sm:text-right ">
              شماره موبایلت رو اینجا برامون بزار تا بهت اخبار جدید رو اطلاع بدیم
            </p>
            <HomeNewCounselingForm data-sentry-element="HomeNewCounselingForm" data-sentry-source-file="HomeNewCounseling.tsx" />
          </div>
          <div className="mb-4 flex w-auto flex-row items-start justify-center lg:justify-end">
            <Image width={400} height={455} src={`${FILE_BROWSER_URL}/img/HomeNew/New_Counseling_Boy2.webp`} alt="New_Counseling_Boy" className="z-10" data-sentry-element="Image" data-sentry-source-file="HomeNewCounseling.tsx" />
          </div>
        </div>
      </Container>
    </div>;
};
export default HomeNewCounseling;